import { cn } from "@/lib/utils";
import { buttonVariants } from "@/src/components/Button/Button";
import { textVariants } from "@/src/components/Text/Text";
import mark from "@assets/greenmark.svg";
import { Link } from "react-router-dom";

const Step3 = () => {
  return (
    <div>
      <div className="flex flex-col items-center md:py-20">
        <img src={mark} className="h-20 w-full" alt="success" />
        <div className="grid gap-1 text-center mt-10">
          <p className={textVariants({ size: "xxl", variant: "link" })}>
            P2P Ad Updated Successfully
          </p>
          <span
            className={cn(textVariants({ variant: "desc" }), "text-center")}
          >
            You have successfully updated this ad.
          </span>
        </div>
        <div className="mt-10 md:mt-20">
          <Link
            to={"/app/trade/myoffers"}
            className={cn(buttonVariants({ variant: "primary" }), "px-14")}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Step3;
